import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Logo } from '../Logo';
export function LaunchNav() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToEOI = () => {
    const element = document.getElementById('eoi-form');
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.16, 1, 0.3, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ease-premium ${isScrolled ? 'bg-[#050505]/80 backdrop-blur-xl border-b border-white/5 py-4' : 'bg-transparent py-6'}`} data-id="element-512">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-513">
        <div className="flex items-center gap-4" data-id="element-514">
          <Logo className="text-2xl" dotClassName="w-1.5 h-1.5 ml-1" data-id="element-515" />
          <div className="h-4 w-px bg-white/20 hidden sm:block" data-id="element-516" />
          <span className="text-xs font-medium tracking-[0.25em] text-gray-400 uppercase hidden sm:block" data-id="element-517">
            Hospitality
          </span>
        </div>

        <button onClick={scrollToEOI} className="bg-brand-orange hover:bg-brand-deep-orange text-white text-sm font-medium px-6 py-2.5 rounded-full transition-all duration-300 shadow-[0_0_0_rgba(219,127,74,0)] hover:shadow-[0_0_20px_rgba(219,127,74,0.2)]" data-id="element-518">
          Register Interest
        </button>
      </div>
    </motion.nav>;
}